import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import "./App.css";
import NavBar from "./components/navbar";
import Intro from "./components/intro";
import BestRates from "./components/bestRates";
import Choose from "./components/choose";
import Footer from "./components/footer";
import Signup from "./Signup";
import ProfilePage from "./ProfilePage";
import Holdings from "./Holdings";

function App() {
  return (
    <Router>
      <div>
        <Route exact path="/crypto/" component={Home} />
        <Route path="/crypto/signup" component={Signup} />
        <Route path="/crypto/profile" component={ProfilePage} />
        <Route path="/crypto/holdings" component={Holdings} />
      </div>
    </Router>
  );
}

function Home() {
  React.useEffect(() => {
    const yoti = window.Yoti.Share.init({
      elements: [
        {
          domId: "loginYoti",
          type: "button",
          clientSdkId: "bfe11401-9161-49a3-8333-c84d4ee6f967",
          scenarioId: "17b96f2b-3da8-4aae-bab9-cd5f84236a9b",
          button: { label: "Use Yoti" }
        }
      ]
    });

    return () => {
      yoti.destroy();
    };
  }, []);

  return (
    <React.Fragment>
      <div className="App">
        <header className="App-header">
          <NavBar />
        </header>
        <Intro />
      </div>
      <BestRates />
      <Choose />
      <Footer />
    </React.Fragment>
  );
}

export default App;
